// src/store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import globalReducer from './globalslice';
import profileReducer from './slices/profileSlice';

const globalPersistConfig = {
  key: 'global', // Clave única para el slice global
  storage,
};

const profilePersistConfig = {
  key: 'profile', // Clave única para el slice profile
  storage,
};

// Reducers persistidos
const rootReducer = combineReducers({
  global: persistReducer(globalPersistConfig, globalReducer),
  profile: persistReducer(profilePersistConfig, profileReducer),
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };
